import { createFileRoute, Outlet } from '@tanstack/react-router';

import { NavigationSidebarSourcing } from '@/areas/sourcing-scenarios/SourcingScenarios/components/NavigationSidebarSourcing';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the project's Sourcing sidebar; a scenario's pages draw it in their own group, and the solution
// manager, the assembly and the offer pages stay outside.
export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { projectId } = Route.useParams();
    return (
        <SidebarRouteLayout sidebar={<NavigationSidebarSourcing rfqId={projectId} />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
